// @flow

import React, {Component} from "react";
import {BrowserRouter, Link, NavLink} from "react-router-dom";

import s from "./PopupForm.scss";
import {all} from "q";
var md5 = require("md5");

export default class PopupForm extends React.Component {
  constructor(props) {
    super(props);

    this.previousStep = null;
    this.form = {};
    this.state = {
      step: 1,

      inputName: "",
      inputCompany: "",
      inputNip: "",
      inputStreet: "",
      inputCode: "",
      inputCity: "",
      inputPhone: "",
      inputEmail: "",
      secondAddress: "",
      inputCheckbox1: "",
      inputCheckbox2: "",
      inputCheckbox3: "",
      inputCheckbox4: "",
      inputCheckbox5: "",
      inputAnotherSample: "",

      validate: {
        inputName: true,
        inputCompany: true,
        inputNip: true,
        inputStreet: true,
        inputCode: true,
        inputCity: true,
        inputPhone: true,
        inputEmail: true,
        inputTexarea: true,
        inputCheckbox1: true,
        inputCheckbox2: true,
        inputCheckbox3: true,
        inputCheckbox4: true,
        inputCheckbox5: true,
        inputAnotherSample: true,
      },

      wasSent: false,
      checkAllAgreements: false,
      isChecked: [false, false, false, false, false],
      showedAlert: [false, false, false, false, false],

      showedAlertWorkProfile: true,
      showedAlertWorkProfileMore: true,
      showedAlertEmploy: true,
      showedAlertProfit: true,

      workProfileChecked: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      workProfileMoreChecked: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],

      showedAlertPosition: true,
      showedAlertPositionMore: true,

      // pracownik wlasciciel
      positionChecked: "",
      //13 pozdycji pracownika
      positionMoreChecked: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      moreWorkProfileOptions: false,

      employChecked: "",
      profitChecked: "",

      sampleChecked: 1,
      sampleName: "Szybki Grunt Evomer 9 kg",

      userExisted: false,
      userId: false,
      userData: false,

      allTags: [],
    };
  }

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  validateInput(value) {
    return value.length > 0;
  }

  validateInputName = (value) => {
    if (value.split(" ").length < 2) {
      return false;
    } else {
      return true;
    }
  };

  checkAllAgreements = () => {
    this.setState({isChecked: [true, true, true, true, true]});
    this.setState({showedAlert: [false, false, false, false, false]});
    this.setState({
      validate: {
        ...this.state.validate,
        inputCheckbox1: true,
        inputCheckbox2: true,
        inputCheckbox3: true,
        inputCheckbox4: true,
        inputCheckbox5: true,
      },
    });
  };

  checkAgreement = (num) => {
    this.setState((prevState) => {
      const newItems = [...prevState.isChecked];
      newItems[num] = !newItems[num];
      return {isChecked: newItems};
    });
    this.showAlert(num);
  };

  checkSample = (num, name) => {
    this.setState({sampleChecked: num, sampleName: name}, this.getTags);
  };

  checkWorkProfile = (e, num) => {
    this.setState((prevState) => {
      const newItems = [...prevState.workProfileChecked];
      newItems[num] = !newItems[num];
      return {workProfileChecked: newItems};
    });
  };

  checkWorkProfileMore = (e, num) => {
    this.setState((prevState) => {
      const newItems = [...prevState.workProfileMoreChecked];
      newItems[num] = !newItems[num];
      return {workProfileMoreChecked: newItems};
    });
  };

  checkPosition = (e) => {
    this.setState({
      positionChecked: e.target.value,
    });
  };

  checkEmploy = (e) => {
    this.setState({
      employChecked: e.target.value,
    });
  };
  checkProfit = (e) => {
    this.setState({
      profitChecked: e.target.value,
    });
  };

  checkPositionMore = (e, num) => {
    this.setState((prevState) => {
      const newItems = [...prevState.positionMoreChecked];
      newItems[num] = !newItems[num];
      return {positionMoreChecked: newItems};
    });
  };

  showAlert = (num) => {
    if (this.state.isChecked[num] == true) {
      this.setState((prevState) => {
        const newItems = [...prevState.showedAlert];
        newItems[num] = true;
        return {showedAlert: newItems};
      });
    } else if (this.state.isChecked[num] == false) {
      this.setState((prevState) => {
        const newItems = [...prevState.showedAlert];
        newItems[num] = false;
        return {showedAlert: newItems};
      });
    }
  };

  validateSample = (e) => {
    if (this.state.sampleChecked < 0) {
      this.setState({sampleChecked: 0});
    }
  };

  validateFirstInput = (e) => {
    e.preventDefault();

    this.handleBlur(false, this.form["inputEmail"]);
    // console.log('przed pierwsza walidacja STATE', this.state.inputEmail, "this.form['inputEmail']", this.form['inputEmail'])

    if (this.handleBlur(false, this.form["inputEmail"])) {
      setTimeout(() => {
        // console.log('validacja pierwszego inputu prawdziwa', "this.form['inputEmail']", this.form['inputEmail'])
        this.checkingSalesManago(this.state.inputEmail);
      }, 2);
    }
  };

  nextStep = (fromNum, toNum, e) => {
    e.preventDefault();

    // console.log('GO TO STEP NUMBER', fromNum, toNum);

    let valid = true;

    let fieldsRequired = [
      [
        "inputName",
        "inputCompany",
        "inputNip",
        "inputStreet",
        "inputCode",
        "inputCity",
        "inputPhone",
      ],
      [
        "inputWorkProfile1",
        "inputWorkProfileMore1",
        "inputWorkProfileMore2",
        "inputWorkProfileMore3",
        "inputWorkProfileMore4",
        "inputWorkProfileMore5",
        "inputWorkProfileMore6",
        "inputWorkProfileMore7",
        "inputWorkProfileMore8",
        "inputWorkProfileMore9",
        "inputWorkProfile2",
        "inputWorkProfile3",
        "inputWorkProfile4",
        "inputWorkProfile5",
        "inputWorkProfile6",
        "inputWorkProfile7",
        "inputWorkProfile8",
        "inputWorkProfile9",
        "inputWorkProfile10",
        "inputWorkProfile11",
        "inputWorkProfile12",
      ],
      [
        "inputPosition1",
        "inputPositionMore1",
        "inputPositionMore2",
        "inputPositionMore3",
        "inputPositionMore4",
        "inputPositionMore5",
        "inputPositionMore6",
        "inputPositionMore7",
        "inputPositionMore8",
        "inputPositionMore9",
        "inputPositionMore10",
        "inputPositionMore11",
        "inputPositionMore12",
        "inputPositionMore13",
        "inputPosition2",
      ],
      [
        "inputEmploy1",
        "inputEmploy2",
        "inputEmploy3",
        "inputEmploy4",
        "inputEmploy5",
        "inputEmploy6",
      ],
      [
        "inputProfit1",
        "inputProfit2",
        "inputProfit3",
        "inputProfit4",
        "inputProfit5",
      ],
      ["inputAnotherSample"],
      [
        "secondAddress",
        "inputCheckbox1",
        "inputCheckbox2",
        "inputCheckbox3",
        "inputCheckbox4",
        "inputCheckbox5",
      ],
    ];

    let requiredArr = [];

    if (fromNum - 2 >= 0 && toNum > fromNum) {
      requiredArr = fieldsRequired[fromNum - 2];

      for (let reqi of requiredArr) {
        // console.log('handle blur THIS FORM REQI', this.form[reqi]);

        let nextValid = this.handleBlur(false, this.form[reqi]);
        // console.log('nextValid', nextValid)

        if (!nextValid) {
          valid = false;
        }
      }

      // console.log('VALID', valid)

      if (toNum == 9 && valid) {
        this.sendForm(e);
      } else if (valid) {
        this.setState({step: toNum});
      }
      //powrot
    } else {
      this.setState({step: toNum});
    }
  };

  showMoreWorkProfileOptions = () => {
    this.setState({moreWorkProfileOptions: !this.state.moreWorkProfileOptions});
  };

  handleBlur = (event = false, target = false) => {
    target = !event ? target : event.target;
    let valid = true;

    // console.log('event', event, 'target', target)
    // console.log('target value', target.value, 'target name', target.name)

    if (target.type == "email") {
      let emailValid = this.validateEmail(target.value);

      // console.log('emailValid', emailValid)

      if (!emailValid) {
        valid = false;
      }

      setTimeout(() => {
        this.setState({
          validate: {
            ...this.state.validate,
            [target.name]: emailValid,
          },
          [target.name]: target.value,
        }, this.getTags()
        );
      }, 1);
    }

    if (target.type == "text" && target.name !== "secondAddress") {
      let textValid = this.validateInput(target.value);

      if (!textValid) {
        valid = false;
      }

      setTimeout(() => {
        this.setState({
          validate: {
            ...this.state.validate,
            [target.name]: textValid,
          },
          [target.name]: target.value,
        });
      }, 1);
    }

    if (target.type == "text" && target.name == "inputName") {
      let textValid = this.validateInputName(target.value);
      if (!textValid) {
        valid = false;
      }
      setTimeout(() => {
        this.setState({
          validate: {
            ...this.state.validate,
            [target.name]: textValid,
          },
          [target.name]: target.value,
        }, this.getTags()
        );
      }, 1);
    }

    if (
      target.type == "checkbox" &&
      target.name !== "sample" &&
      target.name !== "workProfile" &&
      target.name !== "workProfileMore" &&
      target.name != "position" &&
      target.name != "positionMore"
    ) {
      let checkboxValid = target.checked;

      if (!checkboxValid) {
        valid = false;
      }

      setTimeout(() => {
        this.setState({
          validate: {
            ...this.state.validate,
            [target.name]: checkboxValid,
          },
          [target.name]: target.checked,
        });
      }, 1);
    }

    if (target.type == "checkbox" && target.name == "workProfile") {
      // console.log('handle blur input work profile', target);
      let handleCheckboxesState = this.state.workProfileChecked.filter(
        (element) => element == true
      );
      // console.log('handle checkboxes state VALID', handleCheckboxesState.length)

      let workProfileValid;
      handleCheckboxesState.length > 0
        ? (workProfileValid = true)
        : (workProfileValid = false);

      // console.log('work profile valid', workProfileValid)

      if (!workProfileValid) {
        valid = false;
      }

      setTimeout(() => {
        this.setState(
          {
            showedAlertWorkProfile: workProfileValid,
          },
          this.getTags()
        );
      }, 1);
    }

    if (target.type == "checkbox" && target.name == "workProfileWithOptions") {
      if (target.checked) {
        let handleCheckboxesState = this.state.workProfileMoreChecked.filter(
          (element) => element == true
        );
        let workProfileMoreValid;
        handleCheckboxesState.length > 0
          ? (workProfileMoreValid = true)
          : (workProfileMoreValid = false);

        if (!workProfileMoreValid) {
          valid = false;
        }

        setTimeout(() => {
          this.setState(
            {
              showedAlertWorkProfileMore: workProfileMoreValid,
            },
            this.getTags()
          );
        }, 1);
      } else {
        valid = true;
      }
    }

    if (target.type == "radio" && target.name == "position") {
      let positionValid =
        this.state.positionChecked == "wlasciciel" ||
        this.state.positionChecked == "pracownik";

      if (!positionValid) {
        valid = false;
      }

      setTimeout(() => {
        this.setState(
          {
            showedAlertPosition: positionValid,
          },
          this.getTags()
        );
      }, 1);
    }

    if (target.type == "radio" && target.name == "positionWithOptions") {
      if (target.checked) {
        let handleCheckboxesState = this.state.positionMoreChecked.filter(
          (element) => element == true
        );
        let positionMoreValid;
        handleCheckboxesState.length > 0
          ? (positionMoreValid = true)
          : (positionMoreValid = false);

        if (!positionMoreValid) {
          valid = false;
        }

        setTimeout(() => {
          this.setState(
            {
              showedAlertPositionMore: positionMoreValid,
            },
            this.getTags()
          );
        }, 1);
      } else {
        valid = true;
      }
    }

    if (target.type == "radio" && target.name == "employ") {
      let employValid = this.state.employChecked !== "";

      if (!employValid) {
        valid = false;
      }

      setTimeout(() => {
        this.setState(
          {
            showedAlertEmploy: employValid,
          },
          this.getTags()
        );
      }, 1);
    }

    if (target.type == "radio" && target.name == "profit") {
      let profitValid = this.state.profitChecked !== "";

      if (!profitValid) {
        valid = false;
      }

      setTimeout(() => {
        this.setState(
          {
            showedAlertProfit: profitValid,
          },
          this.getTags()
        );
      }, 1);
    }

    return valid;
  };

  getTags = () => {
    let profileTags = [];

    let workProfileAllCheckboxes = document.querySelectorAll(
      "input[name='workProfile']"
    );
    let workProfileMoreAllCheckboxes = document.querySelectorAll(
      "input[name='workProfileMore']"
    );
    let workProfileWithOptions = document.querySelector(
      "input[name='workProfileWithOptions']:checked"
    );

    let jobProfile = document.querySelector("input[name='position']:checked");
    let jobProfileWithOptions = document.querySelector(
      "input[name='positionWithOptions']:checked"
    );
    let jobProfileAllCheckboxes = document.querySelectorAll(
      "input[name='positionMore']"
    );

    let employ = document.querySelector("input[name='employ']:checked");
    let profit = document.querySelector("input[name='profit']:checked");

    let tag;

    if (this.state.sampleChecked === 1) {
      tag = "ZL_LP_EVOMER_SAMPL_0820";
      profileTags.push(tag);
    } else if (this.state.sampleChecked === 2) {
      tag = "ZL_LP_EVOMER_SAMPL_POWLOKA";
      profileTags.push(tag);
    } else if (this.state.sampleChecked === 3) {
      tag = "ZL_LP_EVOMER_SAMPL_CZYSCIK";
      profileTags.push(tag);
    }

    if (workProfileWithOptions) {
      tag = workProfileWithOptions.getAttribute("data-tag");
      profileTags.push(tag);
    }

    if (jobProfile) {
      tag = jobProfile.getAttribute("data-tag");
      profileTags.push(tag);
    }

    if (employ) {
      tag = employ.getAttribute("data-tag");
      profileTags.push(tag);
    }

    if (profit) {
      tag = profit.getAttribute("data-tag");
      profileTags.push(tag);
    }

    if (jobProfileWithOptions) {
      tag = jobProfileWithOptions.getAttribute("data-tag");
      profileTags.push(tag);
    }

    jobProfileAllCheckboxes.forEach((element) => {
      if (element.checked) {
        let tag = element.getAttribute("data-tag");
        profileTags.push(tag);
      }
      return profileTags;
    });

    workProfileAllCheckboxes.forEach((element) => {
      if (element.checked) {
        let tag = element.getAttribute("data-tag");
        profileTags.push(tag);
      }
      return profileTags;
    });

    workProfileMoreAllCheckboxes.forEach((element) => {
      if (element.checked) {
        let tag = element.getAttribute("data-tag");
        profileTags.push(tag);
      }
      return profileTags;
    });

    // console.log('profileTAGS', profileTags)
    this.setState({allTags: profileTags});

    // console.log('state po funkcji get Tags', this.state.allTags);
  };

  sendForm = (e) => {
    e.preventDefault();

    if (!this.state.wasSent) {
      if (this.state.validate) {
        let sampleOrder = {
          inputName: this.state.inputName || this.state.userData.name || "",
          inputCompany:
            this.state.inputCompany || this.state.userData.company || "",
          inputNip: this.state.inputNip || this.state.userData.nip || "",
          inputStreet:
            this.state.inputStreet ||
            this.state.userData.address.streetAddress ||
            "",
          inputCode:
            this.state.inputCode || this.state.userData.address.zipCode || "",
          inputPhone: this.state.inputPhone || this.state.userData.phone || "",
          inputCity:
            this.state.inputCity || this.state.userData.address.city || "",
          inputEmail: this.state.inputEmail || this.state.userData.email || "",
          inputTexarea: this.state.inputTexarea || "",
          inputCheckbox1: this.state.validate.inputCheckbox1,
          inputCheckbox2: this.state.validate.inputCheckbox2,
          inputCheckbox3: this.state.validate.inputCheckbox3,
          inputCheckbox4: this.state.validate.inputCheckbox4,
          inputCheckbox5: this.state.validate.inputCheckbox5,
          inputSample: this.state.sampleName,
          tags: this.state.allTags,
          reasonToReciveSample: this.state.inputAnotherSample,
        };

        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/popup-sample-order", true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(sampleOrder));
        xhr.onload = () => {
          this.setState({
            wasSent: true,
          });

          for (var property in this.form) {
            if (this.form.hasOwnProperty(property)) {
              this.form[property].value = "";
            }
          }
          try {
            window.fbq("track", "Contact");
          } catch (error) {}
          // console.log('Formularz został wysłany.', sampleOrder);
        };
      } else {
        // console.log('didnt send')
      }
    }
  };

  checkingSalesManago = (data) => {
    // console.log('checking sales manago', window.localStorage[md5(data)])

    let step;

    "localStorage" in window && window.localStorage[md5(data)]
      ? (step = window.localStorage[md5(data)])
      : (step = 1);

    // console.log('STEP', step)

    let dataToCheck = {
      inputEmail: data,
      stepNumber: step,
    };

    // console.log('pierwszy local storage', dataToCheck)

    var xhr = new XMLHttpRequest();
    xhr.open("POST", "/checking", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(dataToCheck));
    xhr.onload = () => {
      for (var property in this.form) {
        if (this.form.hasOwnProperty(property)) {
          this.form[property].value = "";
        }
      }

      let res = JSON.parse(xhr.responseText);

      if (res.success) {
        // console.log('succes', res)

        this.setState({
          userExisted: true,
          userId: res.contactId,
          userData: res,
          step: res.stepNumber,
        });

        if ("localStorage" in window) {
          window.localStorage[md5(data)] = res.stepNumber;
        }
        // console.log('UPDATE local storage', res.stepNumber)
      } else {
        // console.log('fail')
        this.setState({userExisted: false, step: 2});
      }
    };
  };

  render() {
    // console.log('render tags', this.state.allTags)
    // console.log('render tags', this.state.userData)

    return (
      <section className="lp-popup-form">
        <div className="popup-form-container container">
          <form className="popup-form" method="post">
            <div
              className={"pop-up-step1" + (this.state.step == 1 ? " show" : "")}
            >
              <h2 className="pop-up__title title-basic">
                Odbierz swoją darmową próbkę <span>Evomer</span>
              </h2>
              <span className="pop-up__subtitle text-basic ">
                Wystarczy, że wypełnisz formularz.
              </span>

              <div className="col-12 popup-samples">
                <div className="popup-samples-box">
                  <input
                    disabled={this.state.wasSent ? "disabled" : ""}
                    checked={this.state.sampleChecked === 1}
                    onChange={() =>
                      this.checkSample(1, "Szybki Grunt Evomer 9 kg")
                    }
                    className={this.state.sampleChecked ? "" : "error"}
                    name="sample"
                    ref={(input) => {
                      this.form.inputSample = input;
                    }}
                    id="sample1"
                    type="checkbox"
                  />
                  <label className="sample-label" htmlFor="sample1">
                    Szybki Grunt Evomer 9 kg
                  </label>
                </div>

                {/* <div className="popup-samples-box">
                  <input disabled={this.state.wasSent ? 'disabled' : ''}
                    checked={this.state.sampleChecked === 2}
                    onChange={() => this.checkSample(2, 'Szybka Powłoka  Evomer 9 kg')}
                    className={this.state.sampleChecked ? '' : 'error'}
                    name='sample'
                    ref={(input) => { this.form.inputSample = input; }} id="sample2" type="checkbox" />
                  <label className='sample-label' htmlFor="sample2">Szybka Powłoka  Evomer 9 kg</label>
                </div> */}
                {/* <div className="popup-samples-box">
                  <input disabled={this.state.wasSent ? 'disabled' : ''}
                    checked={this.state.sampleChecked === 3} onChange={() => this.checkSample(3, 'Czyścik do bitumów')}
                    className={this.state.sampleChecked ? '' : 'error'}
                    name='sample'
                    ref={(input) => { this.form.inputSample = input; }} id="sample3" type="checkbox" />
                  <label className='sample-label' htmlFor="sample3">Czyścik do bitumów</label>
                </div> */}
              </div>

              <div className="basic-contact-inputs">
                <div className="contact-inputs col-12">
                  <div className="col-12 ">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={this.state.validate.inputEmail ? "" : "error"}
                      ref={(input) => {
                        this.form.inputEmail = input;
                      }}
                      type="email"
                      name="inputEmail"
                      placeholder={"E-mail*"}
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 popup-button-container">
                <button
                  onClick={(e) => {
                    this.validateFirstInput(e);
                    this.validateSample(e);
                  }}
                  className="pop-up__button-next button-basic"
                >
                  Dalej
                </button>
              </div>
            </div>

            <div
              className={"pop-up-step2" + (this.state.step == 2 ? " show" : "")}
            >
              <div className="step-2-company-info">
                <span className="pop-up__subtitle text-basic ">
                  Uzupełnij dane firmowe.
                </span>
                <div className="address-contact-inputs">
                  <div className="col-12">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={this.state.validate.inputName ? "" : "error"}
                      ref={(input) => {
                        this.form.inputName = input;
                      }}
                      type="text"
                      name="inputName"
                      placeholder="Imię i Nazwisko*"
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>

                  <div className="col-12 ">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={
                        this.state.validate.inputCompany ? "" : "error"
                      }
                      ref={(input) => {
                        this.form.inputCompany = input;
                      }}
                      type="text"
                      name="inputCompany"
                      placeholder="Nazwa firmy*"
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>

                  <div className="col-12 ">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={this.state.validate.inputNip ? "" : "error"}
                      ref={(input) => {
                        this.form.inputNip = input;
                      }}
                      type="text"
                      name="inputNip"
                      placeholder="NIP*"
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>

                  <div className="col-12 ">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={this.state.validate.inputStreet ? "" : "error"}
                      ref={(input) => {
                        this.form.inputStreet = input;
                      }}
                      type="text"
                      name="inputStreet"
                      placeholder="Ulica, nr domu, nr lokalu*"
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>
                  <div className="col-12 ">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={this.state.validate.inputCode ? "" : "error"}
                      ref={(input) => {
                        this.form.inputCode = input;
                      }}
                      type="text"
                      name="inputCode"
                      placeholder="Kod pocztowy*"
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>
                  <div className="col-12 ">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={this.state.validate.inputCity ? "" : "error"}
                      ref={(input) => {
                        this.form.inputCity = input;
                      }}
                      type="text"
                      name="inputCity"
                      placeholder="Miejscowość*"
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>
                  <div className="col-12 ">
                    <input
                      disabled={this.state.wasSent ? "disabled" : ""}
                      className={this.state.validate.inputPhone ? "" : "error"}
                      ref={(input) => {
                        this.form.inputPhone = input;
                      }}
                      type="text"
                      name="inputPhone"
                      placeholder={"Telefon*"}
                      onBlur={(e) => {
                        this.handleBlur(e);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 popup-button-container">
                <button
                  onClick={(e) => this.nextStep(2, 1, e)}
                  className="pop-up__button-prev button-basic"
                >
                  Wstecz
                </button>
                <button
                  onClick={(e) => {
                    this.nextStep(2, 8, e);
                  }}
                  className="pop-up__button-next button-basic"
                >
                  Dalej
                </button>
              </div>
            </div>

            <div
              className={"pop-up-step3" + (this.state.step == 3 ? " show" : "")}
            >
              <span className="pop-up__subtitle text-basic ">
                Proszę o podanie dominującego profilu działalności FIRMY w
                której PAN/PANI pracuje:
              </span>

              <div className="sdd1-inputs">
                {this.state.showedAlertWorkProfile == false ? (
                  <span className="workprofile-alert">
                    Zaznacz przynajmniej jedną odpowiedź.
                  </span>
                ) : null}

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    id="workProfileWithOptions"
                    name="workProfileWithOptions"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[0]}
                    onChange={(e) => {
                      this.checkWorkProfile(e, 0);
                      this.showMoreWorkProfileOptions();
                    }}
                    data-tag={"SDD1_ogolnobudowlane"}
                    ref={(input) => {
                      this.form.inputWorkProfile1 = input;
                    }}
                    id="workProfile1"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile1">
                    prace ogólnobudowlane
                  </label>

                  <div
                    className={
                      "sdd2-inputs" +
                      (this.state.moreWorkProfileOptions ? " show" : " hide")
                    }
                  >
                    <span className="sdd2__subtitle text-basic">
                      Wybierz podkategorię.
                    </span>

                    {this.state.showedAlertWorkProfileMore == false ? (
                      <span className="workprofile-alert">
                        Zaznacz przynajmniej jedną podkategorię.
                      </span>
                    ) : null}

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[0]}
                        onChange={(e) => this.checkWorkProfileMore(e, 0)}
                        data-tag={"SDD2_wznoszeniowe"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore1 = input;
                        }}
                        id="workProfileMore1"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore1">
                        prace wznoszeniowe
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[1]}
                        onChange={(e) => this.checkWorkProfileMore(e, 1)}
                        data-tag={"SDD2_dekarskie"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore2 = input;
                        }}
                        id="workProfileMore2"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore2">
                        prace dekarskie
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[2]}
                        onChange={(e) => this.checkWorkProfileMore(e, 2)}
                        data-tag={"SDD2_hydroizolacyjne"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore3 = input;
                        }}
                        id="workProfileMore3"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore3">
                        prace hydroizolacyjne
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[3]}
                        onChange={(e) => this.checkWorkProfileMore(e, 3)}
                        data-tag={"SDD2_instalacyjne"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore4 = input;
                        }}
                        id="workProfileMore4"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore4">
                        prace instalacyjne
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[4]}
                        onChange={(e) => this.checkWorkProfileMore(e, 4)}
                        data-tag={"SDD2_wykonczeniowe"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore5 = input;
                        }}
                        id="workProfileMore5"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore5">
                        prace wykończeniowe
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[5]}
                        onChange={(e) => this.checkWorkProfileMore(e, 5)}
                        data-tag={"SDD2_montaz_stolarki_okiennej_lub_drzwiowej"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore6 = input;
                        }}
                        id="workProfileMore6"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore6">
                        montaż stolarki okiennej i drzwiowej
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[6]}
                        onChange={(e) => this.checkWorkProfileMore(e, 6)}
                        data-tag={"SDD2_prace_dociepleniowe"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore7 = input;
                        }}
                        id="workProfileMore7"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore7">
                        prace dociepleniowe
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[7]}
                        onChange={(e) => this.checkWorkProfileMore(e, 7)}
                        data-tag={"SDD2_prace_tynkarskie"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore8 = input;
                        }}
                        id="workProfileMore8"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore8">
                        prace tynkarskie
                      </label>
                    </div>

                    <div className="col-12 sdd2-checkbox-container">
                      <input
                        name="workProfileMore"
                        disabled={!this.state.moreWorkProfileOptions}
                        className={""}
                        checked={this.state.workProfileMoreChecked[8]}
                        onChange={(e) => this.checkWorkProfileMore(e, 8)}
                        data-tag={"SDD2_prace_glazurnicze"}
                        ref={(input) => {
                          this.form.inputWorkProfileMore9 = input;
                        }}
                        id="workProfileMore9"
                        type="checkbox"
                      />
                      <label className="" htmlFor="workProfileMore9">
                        prace glazurnicze
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[1]}
                    onChange={(e) => this.checkWorkProfile(e, 1)}
                    data-tag={"SDD1_wykonczeniowe"}
                    ref={(input) => {
                      this.form.inputWorkProfile2 = input;
                    }}
                    id="workProfile2"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile2">
                    prace wykończeniowe
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[2]}
                    onChange={(e) => this.checkWorkProfile(e, 2)}
                    data-tag={"SDD1_dociepleniowe"}
                    ref={(input) => {
                      this.form.inputWorkProfile3 = input;
                    }}
                    id="workProfile3"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile3">
                    prace dociepleniowe
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[3]}
                    onChange={(e) => this.checkWorkProfile(e, 3)}
                    data-tag={"SDD1_tynkarskie"}
                    ref={(input) => {
                      this.form.inputWorkProfile4 = input;
                    }}
                    id="workProfile4"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile4">
                    prace tynkarskie
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[4]}
                    onChange={(e) => this.checkWorkProfile(e, 4)}
                    data-tag={"SDD1_montaz_stolarki_okiennej_i_drzwiowej"}
                    ref={(input) => {
                      this.form.inputWorkProfile5 = input;
                    }}
                    id="workProfile5"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile5">
                    montaż stolarki okiennej i drzwiowej
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[5]}
                    onChange={(e) => this.checkWorkProfile(e, 5)}
                    data-tag={"SDD1_konstrukcje_i_pokrycia_dachowe"}
                    ref={(input) => {
                      this.form.inputWorkProfile6 = input;
                    }}
                    id="workProfile6"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile6">
                    konstrukcje i pokrycia dachowe
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[6]}
                    onChange={(e) => this.checkWorkProfile(e, 6)}
                    data-tag={"SDD1_prace_hydroizolacyjne_fundamentow"}
                    ref={(input) => {
                      this.form.inputWorkProfile7 = input;
                    }}
                    id="workProfile7"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile7">
                    prace hydroizolacyjne fundamentów
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[7]}
                    onChange={(e) => this.checkWorkProfile(e, 7)}
                    data-tag={
                      "SDD1_prace_hydroizolacyjne_obiektow_inzynieryjnych"
                    }
                    ref={(input) => {
                      this.form.inputWorkProfile8 = input;
                    }}
                    id="workProfile8"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile8">
                    prace hydroizolacyjne obiektów inżynieryjnych
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[8]}
                    onChange={(e) => this.checkWorkProfile(e, 8)}
                    data-tag={"SDD1_generalny_wykonawca"}
                    ref={(input) => {
                      this.form.inputWorkProfile9 = input;
                    }}
                    id="workProfile9"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile9">
                    generalny wykonawca
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[9]}
                    onChange={(e) => this.checkWorkProfile(e, 9)}
                    data-tag={
                      "SDD1_prace_instalacyjne_wod.kan,_elektryczne,_HVAC"
                    }
                    ref={(input) => {
                      this.form.inputWorkProfile10 = input;
                    }}
                    id="workProfile10"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile10">
                    prace instalacyjne, wodno-kanalizacyjne, elektryczne, HVAC{" "}
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[10]}
                    onChange={(e) => this.checkWorkProfile(e, 10)}
                    data-tag={"SDD1_Fasady_wentylowane"}
                    ref={(input) => {
                      this.form.inputWorkProfile11 = input;
                    }}
                    id="workProfile11"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile11">
                    fasady wentylowane
                  </label>
                </div>

                <div className="col-12 sdd1-checkbox-container">
                  <input
                    name="workProfile"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.workProfileChecked[11]}
                    onChange={(e) => this.checkWorkProfile(e, 11)}
                    data-tag={"SDD1_Sucha_zabudowa"}
                    ref={(input) => {
                      this.form.inputWorkProfile12 = input;
                    }}
                    id="workProfile12"
                    type="checkbox"
                  />
                  <label className="" htmlFor="workProfile12">
                    sucha zabudowa
                  </label>
                </div>
              </div>

              <div className="col-12 popup-button-container">
                <button
                  onClick={(e) => this.nextStep(3, 1, e)}
                  className="pop-up__button-prev button-basic"
                >
                  Wstecz
                </button>
                <button
                  onClick={(e) => {
                    this.nextStep(3, 8, e);
                  }}
                  className="pop-up__button-next button-basic"
                >
                  Dalej
                </button>
              </div>
            </div>

            <div
              className={"pop-up-step4" + (this.state.step == 4 ? " show" : "")}
            >
              <span className="pop-up__subtitle text-basic ">
                Proszę o określenie Pana/Pani roli w firmie (profilu
                pracownika):
              </span>

              <div className="pp1-inputs">
                {this.state.showedAlertPosition == false ? (
                  <span className="position-alert">
                    Zaznacz przynajmniej jedną odpowiedź.
                  </span>
                ) : null}

                <div className="col-12 pp1-checkbox-container">
                  <input
                    name="position"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.positionChecked == "wlasciciel"}
                    onChange={(e) => this.checkPosition(e)}
                    value={"wlasciciel"}
                    data-tag={"PP1_wlasciciel"}
                    ref={(input) => {
                      this.form.inputPosition1 = input;
                    }}
                    id="position1"
                    type="radio"
                  />
                  <label className="" htmlFor="position1">
                    właściciel
                  </label>
                </div>

                <div className="col-12 pp1-checkbox-container">
                  <input
                    id="positionWithOptions"
                    name="positionWithOptions"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.positionChecked == "pracownik"}
                    value={"pracownik"}
                    onChange={(e) => {
                      this.checkPosition(e);
                    }}
                    data-tag={"PP1_pracownik"}
                    ref={(input) => {
                      this.form.inputPosition2 = input;
                    }}
                    id="position2"
                    type="radio"
                  />
                  <label className="" htmlFor="position2">
                    pracownik
                  </label>

                  <div
                    className={
                      "pp2-inputs" +
                      (this.state.positionChecked === "pracownik"
                        ? " show"
                        : " hide")
                    }
                  >
                    {this.state.showedAlertPositionMore == false ? (
                      <span className="position-alert">
                        Zaznacz przynajmniej jedną podkategorię.
                      </span>
                    ) : null}

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[0]}
                        onChange={(e) => this.checkPositionMore(e, 0)}
                        data-tag={"PP2_manager_ds._zakupow"}
                        ref={(input) => {
                          this.form.inputPositionMore1 = input;
                        }}
                        id="positionMore1"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore1">
                        manager ds. zakupów
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[1]}
                        onChange={(e) => this.checkPositionMore(e, 1)}
                        data-tag={"PP2_doradca_techniczny"}
                        ref={(input) => {
                          this.form.inputPositionMore2 = input;
                        }}
                        id="positionMore2"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore2">
                        doradca techniczny
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[2]}
                        onChange={(e) => this.checkPositionMore(e, 2)}
                        data-tag={"PP2_kierownik_budowy"}
                        ref={(input) => {
                          this.form.inputPositionMore3 = input;
                        }}
                        id="positionMore3"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore3">
                        kierownik budowy
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[3]}
                        onChange={(e) => this.checkPositionMore(e, 3)}
                        data-tag={"PP2_inspektor_nadzoru"}
                        ref={(input) => {
                          this.form.inputPositionMore4 = input;
                        }}
                        id="positionMore4"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore4">
                        inspektor nadzoru
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[4]}
                        onChange={(e) => this.checkPositionMore(e, 4)}
                        data-tag={"PP2_monter_stolarki"}
                        ref={(input) => {
                          this.form.inputPositionMore5 = input;
                        }}
                        id="positionMore5"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore5">
                        monter stolarki
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[5]}
                        onChange={(e) => this.checkPositionMore(e, 5)}
                        data-tag={"PP2_dekarz"}
                        ref={(input) => {
                          this.form.inputPositionMore6 = input;
                        }}
                        id="positionMore6"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore6">
                        dekarz
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[6]}
                        onChange={(e) => this.checkPositionMore(e, 6)}
                        data-tag={"PP2_tynkarz"}
                        ref={(input) => {
                          this.form.inputPositionMore7 = input;
                        }}
                        id="positionMore7"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore7">
                        tynkarz
                      </label>
                    </div>
                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[7]}
                        onChange={(e) => this.checkPositionMore(e, 7)}
                        data-tag={"PP2_glazurnik"}
                        ref={(input) => {
                          this.form.inputPositionMore8 = input;
                        }}
                        id="positionMore8"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore8">
                        glazurnik
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[8]}
                        onChange={(e) => this.checkPositionMore(e, 8)}
                        data-tag={"PP2_ociepleniowiec"}
                        ref={(input) => {
                          this.form.inputPositionMore9 = input;
                        }}
                        id="positionMore9"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore9">
                        ociepleniowiec
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[9]}
                        onChange={(e) => this.checkPositionMore(e, 9)}
                        data-tag={"PP2_specjalista_ds._robot_wykonczeniowych"}
                        ref={(input) => {
                          this.form.inputPositionMore10 = input;
                        }}
                        id="positionMore10"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore10">
                        specjalista ds. robot wykonczeniowych
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[10]}
                        onChange={(e) => this.checkPositionMore(e, 10)}
                        data-tag={"PP2_murarz"}
                        ref={(input) => {
                          this.form.inputPositionMore11 = input;
                        }}
                        id="positionMore11"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore11">
                        murarz
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[11]}
                        onChange={(e) => this.checkPositionMore(e, 11)}
                        data-tag={"PP2_specjalista_ds._suchej_zabudowy"}
                        ref={(input) => {
                          this.form.inputPositionMore12 = input;
                        }}
                        id="positionMore12"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore12">
                        specjalista ds. suchej zabudowy
                      </label>
                    </div>

                    <div className="col-12 pp2-checkbox-container">
                      <input
                        name="positionMore"
                        disabled={this.state.positionChecked == "wlasciciel"}
                        className={""}
                        checked={this.state.positionMoreChecked[12]}
                        onChange={(e) => this.checkPositionMore(e, 12)}
                        data-tag={"PP2_wykonawca_gladzi_gipsowych_-_malarz"}
                        ref={(input) => {
                          this.form.inputPositionMore13 = input;
                        }}
                        id="positionMore13"
                        type="checkbox"
                      />
                      <label className="" htmlFor="positionMore13">
                        wykonawca gładzi gipsowych - malarz
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 popup-button-container">
                <button
                  onClick={(e) => this.nextStep(4, 1, e)}
                  className="pop-up__button-prev button-basic"
                >
                  Wstecz
                </button>
                <button
                  onClick={(e) => {
                    this.nextStep(4, 8, e);
                  }}
                  className="pop-up__button-next button-basic"
                >
                  Dalej
                </button>
              </div>
            </div>

            <div
              className={"pop-up-step5" + (this.state.step == 5 ? " show" : "")}
            >
              <span className="pop-up__subtitle text-basic ">
                Proszę o podanie ilości osób zatrudnionych w firmie:
              </span>

              <div className="zat-inputs">
                {this.state.showedAlertEmploy == false ? (
                  <span className="position-alert">
                    Zaznacz przynajmniej jedną odpowiedź.
                  </span>
                ) : null}

                <div className="col-12 zat-checkbox-container">
                  <input
                    name="employ"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.employChecked == "jdg"}
                    onChange={(e) => this.checkEmploy(e)}
                    value={"jdg"}
                    data-tag={"ZATRUDNIENIE_1_(JDG)"}
                    ref={(input) => {
                      this.form.inputEmploy1 = input;
                    }}
                    id="employ1"
                    type="radio"
                  />
                  <label className="" htmlFor="employ1">
                    1 (jednoosobowa działalność)
                  </label>
                </div>

                <div className="col-12 zat-checkbox-container">
                  <input
                    name="employ"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.employChecked == "1-9"}
                    onChange={(e) => this.checkEmploy(e)}
                    value={"1-9"}
                    data-tag={"ZATRUDNIENIE_od_1_do_9"}
                    ref={(input) => {
                      this.form.inputEmploy2 = input;
                    }}
                    id="employ2"
                    type="radio"
                  />
                  <label className="" htmlFor="employ2">
                    od 1 do 9
                  </label>
                </div>

                <div className="col-12 zat-checkbox-container">
                  <input
                    name="employ"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.employChecked == "10-49"}
                    onChange={(e) => this.checkEmploy(e)}
                    value={"10-49"}
                    data-tag={"ZATRUDNIENIE_od_10_do_49"}
                    ref={(input) => {
                      this.form.inputEmploy3 = input;
                    }}
                    id="employ3"
                    type="radio"
                  />
                  <label className="" htmlFor="employ3">
                    od 10 do 49
                  </label>
                </div>

                <div className="col-12 zat-checkbox-container">
                  <input
                    name="employ"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.employChecked == "50-99"}
                    onChange={(e) => this.checkEmploy(e)}
                    value={"50-99"}
                    data-tag={"ZATRUDNIENIE_od_50_do_99"}
                    ref={(input) => {
                      this.form.inputEmploy4 = input;
                    }}
                    id="employ4"
                    type="radio"
                  />
                  <label className="" htmlFor="employ4">
                    od 50 do 99
                  </label>
                </div>

                <div className="col-12 zat-checkbox-container">
                  <input
                    name="employ"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.employChecked == "100-249"}
                    onChange={(e) => this.checkEmploy(e)}
                    value={"100-249"}
                    data-tag={"ZATRUDNIENIE_od_100_do_249"}
                    ref={(input) => {
                      this.form.inputEmploy5 = input;
                    }}
                    id="employ5"
                    type="radio"
                  />
                  <label className="" htmlFor="employ5">
                    od 100 do 249
                  </label>
                </div>

                <div className="col-12 zat-checkbox-container">
                  <input
                    name="employ"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.employChecked == "powyzej250"}
                    onChange={(e) => this.checkEmploy(e)}
                    value={"powyzej250"}
                    data-tag={"ZATRUDNIENIE_powyzej_250"}
                    ref={(input) => {
                      this.form.inputEmploy6 = input;
                    }}
                    id="employ6"
                    type="radio"
                  />
                  <label className="" htmlFor="employ6">
                    powyżej 250
                  </label>
                </div>
              </div>
              <div className="col-12 popup-button-container">
                <button
                  onClick={(e) => this.nextStep(5, 1, e)}
                  className="pop-up__button-prev button-basic"
                >
                  Wstecz
                </button>
                <button
                  onClick={(e) => {
                    this.nextStep(5, 8, e);
                  }}
                  className="pop-up__button-next button-basic"
                >
                  Dalej
                </button>
              </div>
            </div>

            <div
              className={"pop-up-step6" + (this.state.step == 6 ? " show" : "")}
            >
              <span className="pop-up__subtitle text-basic ">
                Proszę o podanie szacowanego obrotu rocznego firmy (kPLN):{" "}
              </span>
              <div className="obr-inputs">
                {this.state.showedAlertProfit == false ? (
                  <span className="position-alert">
                    Zaznacz przynajmniej jedną odpowiedź.
                  </span>
                ) : null}

                <div className="col-12 obr-checkbox-container">
                  <input
                    name="profit"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.profitChecked == "10"}
                    onChange={(e) => this.checkProfit(e)}
                    value={"10"}
                    data-tag={"OBROTY_do_10"}
                    ref={(input) => {
                      this.form.inputProfit1 = input;
                    }}
                    id="profit1"
                    type="radio"
                  />
                  <label className="" htmlFor="profit1">
                    do 10 tys.
                  </label>
                </div>

                <div className="col-12 obr-checkbox-container">
                  <input
                    name="profit"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.profitChecked == "10-49"}
                    onChange={(e) => this.checkProfit(e)}
                    value={"10-49"}
                    data-tag={"OBROTY_od_10_do_49"}
                    ref={(input) => {
                      this.form.inputProfit2 = input;
                    }}
                    id="profit2"
                    type="radio"
                  />
                  <label className="" htmlFor="profit2">
                    od 10 do 49 tys.
                  </label>
                </div>

                <div className="col-12 obr-checkbox-container">
                  <input
                    name="profit"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.profitChecked == "49-100"}
                    onChange={(e) => this.checkProfit(e)}
                    value={"49-100"}
                    data-tag={"OBROTY_od_49_do_100"}
                    ref={(input) => {
                      this.form.inputProfit3 = input;
                    }}
                    id="profit3"
                    type="radio"
                  />
                  <label className="" htmlFor="profit3">
                    od 49 do 100 tys.
                  </label>
                </div>

                <div className="col-12 obr-checkbox-container">
                  <input
                    name="profit"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.profitChecked == "100-1000"}
                    onChange={(e) => this.checkProfit(e)}
                    value={"100-1000"}
                    data-tag={"OBROTY_od_100_do_1000"}
                    ref={(input) => {
                      this.form.inputProfit4 = input;
                    }}
                    id="profit4"
                    type="radio"
                  />
                  <label className="" htmlFor="profit4">
                    od 100 do 1000 tys.
                  </label>
                </div>

                <div className="col-12 obr-checkbox-container">
                  <input
                    name="profit"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={""}
                    checked={this.state.profitChecked == "powyzej1000"}
                    onChange={(e) => this.checkProfit(e)}
                    value={"powyzej1000"}
                    data-tag={"OBROTY_powyzej_1000"}
                    ref={(input) => {
                      this.form.inputProfit5 = input;
                    }}
                    id="profit5"
                    type="radio"
                  />
                  <label className="" htmlFor="profit5">
                    powyżej 1000 tys.
                  </label>
                </div>
              </div>
              <div className="col-12 popup-button-container">
                <button
                  onClick={(e) => this.nextStep(6, 1, e)}
                  className="pop-up__button-prev button-basic"
                >
                  Wstecz
                </button>
                <button
                  onClick={(e) => {
                    this.nextStep(6, 8, e);
                  }}
                  className="pop-up__button-next button-basic"
                >
                  Dalej
                </button>
              </div>
            </div>

            <div
              className={"pop-up-step7" + (this.state.step == 7 ? " show" : "")}
            >
              <span className="pop-up__subtitle text-basic ">
                Czy chciałbyś otrzymać kolejną próbkę? Napisz nam dlaczego.
              </span>
              <div className="another-sample col-12">
                <div className="col-12">
                  <input
                    type="text"
                    className={
                      this.state.validate.inputAnotherSample ? "" : "error"
                    }
                    disabled={this.state.wasSent ? "disabled" : ""}
                    ref={(input) => {
                      this.form.inputAnotherSample = input;
                    }}
                    name="inputAnotherSample"
                    placeholder="Dlaczego chciałbyś otrzymać kolejną próbkę?"
                    defaultValue={""}
                    onBlur={(e) => this.handleBlur(e)}
                  />
                </div>
              </div>
              <div className="col-12 popup-button-container">
                <button
                  onClick={(e) => this.nextStep(7, 1, e)}
                  className="pop-up__button-prev button-basic"
                >
                  Wstecz
                </button>
                <button
                  onClick={(e) => {
                    this.nextStep(7, 8, e);
                  }}
                  className="pop-up__button-next button-basic"
                >
                  Dalej
                </button>
              </div>
            </div>

            <div
              className={"pop-up-step8" + (this.state.step == 8 ? " show" : "")}
            >
              <span className="pop-up__subtitle text-basic ">
                Uzupełnij adres do wysyłki i zaznacz zgody.
              </span>
              <div className="agreement-contact-inputs col-12">
                <div className="col-12">
                  <textarea
                    className="form-textarea"
                    disabled={this.state.wasSent ? "disabled" : ""}
                    ref={(input) => {
                      this.form.inputTexarea = input;
                    }}
                    name="secondAddress"
                    placeholder="Adres do wysyłki (jeśli inny niż powyższy)"
                    defaultValue={""}
                    onBlur={(e) => {
                      this.handleBlur(e);
                    }}
                  />
                </div>

                <span
                  onClick={() => this.checkAllAgreements()}
                  className="check-all"
                >
                  Zaznacz wszystkie
                </span>
                <div className="col-12 checkbox-container">
                  <input
                    disabled={this.state.wasSent ? "disabled" : ""}
                    checked={
                      this.state.isChecked[0] || this.state.checkAllAgreements
                    }
                    onChange={(e) => {
                      this.checkAgreement(0);
                      this.handleBlur(e);
                    }}
                    className={
                      this.state.validate.inputCheckbox1 ? "" : "error"
                    }
                    ref={(input) => {
                      this.form.inputCheckbox1 = input;
                    }}
                    name="inputCheckbox1"
                    id="cb1"
                    type="checkbox"
                  />

                  <label htmlFor="cb1">
                    Wyrażam zgodę na przetwarzanie wskazanych w zgłoszeniu
                    danych osobowych w celach związanych z przeprowadzeniem
                    Promocji oraz postępowania reklamacyjnego w Promocji.
                    Przekazuję dane osobowe w sposób dobrowolny. Jestem
                    świadomy, że mam prawo dostępu do treści podanych danych
                    osobowych oraz prawo żądania ich poprawiania.
                    Administratorem danych osobowych jest Organizator, tj.
                    spółka Selena SA z siedzibą we Wrocławiu (adres: ul.
                    Wyścigowa 56E, 53-012 Wrocław), wpisana do rejestru
                    przedsiębiorców KRS przez Sąd Rejonowy dla
                    Wrocławia-Fabrycznej we Wrocławiu, VI Wydział Gospodarczy
                    Krajowego Rejestru Sądowego, pod numerem KRS 0000112580,
                    numer NIP 894-000-55-23.
                  </label>

                  {this.state.showedAlert[0] ||
                  this.state.validate.inputCheckbox1 == false ? (
                    <span className="agreement-alert">
                      Wyrażenie zgody jest wymagane
                    </span>
                  ) : null}
                </div>

                <div className="col-12 checkbox-container">
                  <input
                    disabled={this.state.wasSent ? "disabled" : ""}
                    checked={
                      this.state.isChecked[1] || this.state.checkAllAgreements
                    }
                    onChange={(e) => {
                      this.checkAgreement(1);
                      this.handleBlur(e);
                    }}
                    className={
                      this.state.validate.inputCheckbox2 ? "" : "error"
                    }
                    ref={(input) => {
                      this.form.inputCheckbox2 = input;
                    }}
                    name="inputCheckbox2"
                    id="cb2"
                    type="checkbox"
                  />
                  <label htmlFor="cb2">
                    Wyrażam zgodę na otrzymywanie od SELENA S.A. drogą
                    elektroniczną na wskazany przeze mnie w Formularzu adres
                    e-mail informacji handlowych, dotyczących produktów i usług
                    oferowanych przez SELENA S.A. w rozumieniu ustawy z dnia 18
                    lipca 2002 r. o świadczeniu usług drogą elektroniczną (t.j.
                    Dz. U z 2017 r., poz. 1219 ze zm.). Przyjmuję do wiadomości,
                    że zgoda ma charakter dobrowolny i może być w każdym czasie
                    odwołana
                  </label>
                  {this.state.showedAlert[1] ||
                  this.state.validate.inputCheckbox2 == false ? (
                    <span className="agreement-alert">
                      Wyrażenie zgody jest wymagane
                    </span>
                  ) : null}
                </div>

                <div className="col-12 checkbox-container">
                  <input
                    disabled={this.state.wasSent ? "disabled" : ""}
                    checked={
                      this.state.isChecked[2] || this.state.checkAllAgreements
                    }
                    onChange={(e) => {
                      this.checkAgreement(2);
                      this.handleBlur(e);
                    }}
                    className={
                      this.state.validate.inputCheckbox3 ? "" : "error"
                    }
                    ref={(input) => {
                      this.form.inputCheckbox3 = input;
                    }}
                    name="inputCheckbox3"
                    id="cb3"
                    type="checkbox"
                  />
                  <label htmlFor="cb3">
                    Wyrażam zgodę na otrzymywanie od SELENA S.A. drogą
                    elektroniczną na wskazany przeze mnie adres e-mail
                    informacji handlowych w celach marketingowych podmiotów
                    współpracujących z SELENA S.A. (w szczególności spółek z
                    Grupy SELENA) przez czas i w zakresie współpracy z SELENA
                    S.A. w rozumieniu ustawy z dnia 18 lipca 2002 r. o
                    świadczeniu usług drogą elektroniczną (t.j. Dz. U z 2017 r.,
                    poz. 1219 ze zm.). Przyjmuję do wiadomości, że zgoda ma
                    charakter dobrowolny i może być w każdym czasie odwołana.
                  </label>
                  {this.state.showedAlert[2] ||
                  this.state.validate.inputCheckbox3 == false ? (
                    <span className="agreement-alert">
                      Wyrażenie zgody jest wymagane
                    </span>
                  ) : null}
                </div>

                <div className="col-12 checkbox-container">
                  <input
                    disabled={this.state.wasSent ? "disabled" : ""}
                    checked={
                      this.state.isChecked[3] || this.state.checkAllAgreements
                    }
                    onChange={(e) => {
                      this.checkAgreement(3);
                      this.handleBlur(e);
                    }}
                    className={
                      this.state.validate.inputCheckbox4 ? "" : "error"
                    }
                    ref={(input) => {
                      this.form.inputCheckbox4 = input;
                    }}
                    name="inputCheckbox4"
                    id="cb4"
                    type="checkbox"
                  />
                  <label htmlFor="cb4">
                    Wyrażam zgodę na przekazywanie przez SELENA S.A. treści,
                    dotyczących oferty SELENA S.A. na podany przeze mnie numer
                    telefonu, w tym przy użyciu automatycznych systemów
                    wywołujących w rozumieniu ustawy z dnia 16 lipca 2004 r.
                    Prawo telekomunikacyjne (Dz. U z 2017 r. poz. 1907 ze zm.).
                    Przyjmuję do wiadomości, że zgoda ma charakter dobrowolny i
                    może być w każdym czasie odwołana.
                  </label>
                  {this.state.showedAlert[3] ||
                  this.state.validate.inputCheckbox4 == false ? (
                    <span className="agreement-alert">
                      Wyrażenie zgody jest wymagane
                    </span>
                  ) : null}
                </div>

                <div className="col-12 checkbox-container">
                  <input
                    disabled={this.state.wasSent ? "disabled" : ""}
                    checked={
                      this.state.isChecked[4] || this.state.checkAllAgreements
                    }
                    onChange={(e) => {
                      this.checkAgreement(4);
                      this.handleBlur(e);
                    }}
                    className={
                      this.state.validate.inputCheckbox5 ? "" : "error"
                    }
                    ref={(input) => {
                      this.form.inputCheckbox5 = input;
                    }}
                    name="inputCheckbox5"
                    id="cb5"
                    type="checkbox"
                  />

                  <label htmlFor="cb5">
                    Wyrażam zgodę na przetwarzanie moich danych osobowych przez
                    SELENĘ SA oraz podmioty współpracujące z SELENA S.A. (w
                    szczególności spółki z Grupy SELENA) w celu marketingu
                    bezpośredniego dotyczącego produktów i usług oferowanych
                    przez w/w podmioty, wykonywanego przy użyciu
                    telekomunikacyjnych urządzeń końcowych oraz automatycznych
                    systemów wywołujących, zgodnie z art. 172 ustawy z dnia 16
                    lipca 2004r. Prawo telekomunikacyjne (Dz. U. z 2017 r. poz.
                    1907 ze zm.). Przyjmuję do wiadomości, że zgoda ma charakter
                    dobrowolny i może być w każdym czasie odwołana.
                  </label>
                  {this.state.showedAlert[4] ||
                  this.state.validate.inputCheckbox5 == false ? (
                    <span className="agreement-alert">
                      Wyrażenie zgody jest wymagane
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="popup-button-container">
                <button
                  onClick={(e) => this.nextStep(8, 1, e)}
                  className="pop-up__button-prev button-basic"
                >
                  Wstecz
                </button>
                <button
                  className="order-form-button button-basic"
                  onClick={(e) => this.nextStep(8, 9, e)}
                >
                  Zamów próbkę
                </button>
              </div>
            </div>
          </form>

          {this.state.wasSent ? (
            <h4 className="form-sent-info text-basic">
              Formularz został wysłany.
            </h4>
          ) : (
            ""
          )}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PopupForm/PopupForm.js